import type { TenantRole } from "@shared-domain/auth-service/contract";

/**
 * PRODUCT_DEV-1235: テナントの役割の呼び名と説明の正本（ユーザー一覧・ユーザー詳細・新規作成で同じものを出す）。
 * 並びは弱い順。値の正本は `@shared-domain/auth-service/contract` の `TENANT_ROLES`。
 *
 * 呼び名は 2026-10-29 に決めた画面の呼び名（管理者 → 管理ユーザー、間にパワーユーザーを足した）。
 * できることの正本は `@shared-domain/unizo/permissions` の表で、説明はその要約。
 */
export const TENANT_ROLE_OPTIONS: readonly {
  value: TenantRole;
  label: string;
  description: string;
}[] = [
  { value: "viewer", label: "閲覧者", description: "記録を見るだけ" },
  { value: "member", label: "メンバー", description: "自分の記録を作る・直す" },
  {
    value: "power",
    label: "パワーユーザー",
    description:
      "メンバーに加えて、記録を全件見る・他人の記録を直す・データ出力・部署と顧客マスタ・辞書・配信の設定",
  },
  {
    value: "admin",
    label: "管理ユーザー",
    description:
      "パワーユーザーに加えて、ユーザー管理・セキュリティ設定・記録の完全削除",
  },
];

/** 役割の呼び名。知らない値はメンバーとして見せる（古い画面が新しい値を受け取ったときと同じ倒し方）。 */
export const tenantRoleLabel = (role: string | undefined): string =>
  TENANT_ROLE_OPTIONS.find((o) => o.value === role)?.label ?? "メンバー";
